export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StoryStatusBar.vue?vue&type=template&id=1c2d50e4&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryStatusBar.vue?vue&type=template&id=1c2d50e4&scoped=true&
// module id = 1044
// module chunks = 0